import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.members/view.scss */
:host {
  display: block;
  height: 100%;
}

.organization-node-rail {
  width: 4px;
  min-width: 4px;
  border-radius: 9999px;
  margin-top: 0.45rem;
}

.organization-node-card,
.organization-picker-card {
  border: 1px solid #e4e4e7;
  border-radius: 1rem;
  transition: border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease, background-color 140ms ease;
}

.organization-picker-card {
  width: 100%;
}

.organization-node-card:hover,
.organization-picker-card:hover {
  border-color: #cbd5e1;
}

.organization-picker-card:hover {
  transform: translateY(-1px);
}

.organization-picker-card.selected {
  border-color: #818cf8;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.14);
}

.organization-node-name {
  line-height: 1.2;
}

.organization-node-meta,
.organization-node-description {
  line-height: 1.35;
}

.organization-node-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.125rem 0.5rem;
  font-size: 11px;
  font-weight: 600;
}

.organization-node-card.depth-0,
.organization-picker-card.depth-0 {
  background: linear-gradient(135deg, #fafafa 0%, #f4f4f5 100%);
}

.organization-node-card.depth-1,
.organization-picker-card.depth-1 {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
}

.organization-node-card.depth-2,
.organization-picker-card.depth-2 {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
}

.organization-node-card.depth-3,
.organization-picker-card.depth-3 {
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
}

.organization-node-rail.depth-0 {
  background: #18181b;
}

.organization-node-rail.depth-1 {
  background: #0284c7;
}

.organization-node-rail.depth-2 {
  background: #059669;
}

.organization-node-rail.depth-3 {
  background: #d97706;
}

.organization-node-name.depth-0 {
  color: #18181b;
  font-size: 14px;
  font-weight: 700;
}

.organization-node-name.depth-1 {
  color: #0c4a6e;
  font-size: 13.5px;
  font-weight: 700;
}

.organization-node-name.depth-2 {
  color: #065f46;
  font-size: 13px;
  font-weight: 600;
}

.organization-node-name.depth-3 {
  color: #92400e;
  font-size: 12.5px;
  font-weight: 600;
}

.organization-node-meta.depth-0,
.organization-node-description.depth-0 {
  color: #52525b;
}

.organization-node-meta.depth-1,
.organization-node-description.depth-1 {
  color: #0369a1;
}

.organization-node-meta.depth-2,
.organization-node-description.depth-2 {
  color: #047857;
}

.organization-node-meta.depth-3,
.organization-node-description.depth-3 {
  color: #b45309;
}

.organization-node-meta {
  font-size: 11px;
}

.organization-node-description {
  font-size: 12px;
}

.organization-node-badge.depth-0 {
  background: #18181b;
  color: #ffffff;
}

.organization-node-badge.depth-1 {
  background: #e0f2fe;
  color: #0369a1;
}

.organization-node-badge.depth-2 {
  background: #d1fae5;
  color: #047857;
}

.organization-node-badge.depth-3 {
  background: #ffedd5;
  color: #b45309;
}

.log-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`],
})
export class PageMembersComponent implements OnInit, OnDestroy {
    private readonly POLICY_GROUP_LABELS: any = {
        basic: 'Basic',
        image: 'Images',
        settings: 'Settings',
        tools: 'Tools',
        logs: 'Logs',
        misc: 'Misc',
    };
    private readonly POLICY_MENU_LABELS: any = {
        dashboard: 'Dashboard',
        rack_view: 'Rack View',
        provisioning_rack_view: 'Deployment Rack View',
        actions: 'Actions',
        groups: 'Groups',
        nodes: 'Nodes',
        clusters: 'Clusters',
        relay: 'Relay',
        script_config: 'Script Config',
        images: 'Images',
        diskless: 'Diskless Images',
        subnets: 'Subnets',
        debug: 'Debug',
        ssh_access: 'SSH Access Management',
        cluster_users: 'Cluster User Management',
        members: 'User Management',
        pe: 'PE',
        zabbix: 'Zabbix',
        lustre: 'Lustre',
        job_management: 'Job Management',
        juju: 'Juju',
        public_api: 'Swagger',
        inspect: 'Inspect',
        service_logs: 'Service / Async Logs',
        assistant: 'AI Assistant',
        help: 'Help',
    };
    private readonly ACTIVITY_EVENT_LABELS: any = {
        login: 'Login',
        logout: 'Logout',
        actions: 'Action Run',
        cluster: 'Cluster Operation',
        relay: 'Relay Run',
        assistant: 'AI Tool Run',
        ipmi_scan: 'IPMI Scan',
        node: 'Node Management',
        group: 'Group Management',
        zone: 'Zone / Rack Management',
        bmc_monitor: 'BMC Monitoring',
        account: 'Account Management',
        key_management: 'SSH Key Management',
        chassis: 'Chassis Management',
        image: 'Image Management',
        script: 'Script Management',
        subnet: 'Subnet Management',
        pe: 'PE Management',
        bmc_credential: 'BMC Credential Management',
        service_log: 'Service Log Management',
        log_policy: 'Log Policy Management',
        integration: 'Integration',
        post: 'Post Management',
        configuration: 'Configuration',
    };
    public loading: boolean = false;
    public error: string = '';
    public members: any[] = [];
    public currentRole: string = 'viewer';
    public canManageMembers: boolean = false;
    public canViewUserLogs: boolean = false;
    public logPolicy: any = { user_activity: true };
    public activeTab: string = 'members';
    public organizations: any[] = [];
    public logUsers: any[] = [];
    public activityEventTypes: any[] = [];
    public logsLoading: boolean = false;
    public userLogs: any[] = [];
    public logFilters: any = { user_id: '', event_type: '', start_date: '', end_date: '' };
    public logPagination: any = { page: 1, dump: 50, total: 0 };

    public search: any = {
        text: "",
        role: ""
    };

    public roles: string[] = [];
    public assignableRoles: string[] = [];

    public showInviteModal: boolean = false;
    public inviteData: any = { email: '', role: 'viewer', password: '' };
    public showMemberEditModal: boolean = false;
    public memberEditData: any = { id: '', name: '', email: '', password: '', confirm_password: '' };
    public sidebarPolicy: any = {};
    public sidebarPolicyRoles: string[] = ['admin', 'operator', 'viewer'];
    public selectedPolicyRole: string = 'admin';
    public sidebarPolicySections: any[] = [];
    public permissionActions: any[] = [
        { key: 'read', label: '' },
        { key: 'create', label: '' },
        { key: 'update', label: '' },
        { key: 'remove', label: '' },
        { key: 'execute', label: '' },
    ];
    public policyDirty: boolean = false;
    public savingPolicy: boolean = false;
    private langSub: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.langSub = this.translate.onLangChange.subscribe(async () => {
            this.permissionActions = (this.permissionActions || []).map((action: any) => ({
                ...action,
                label: this.permissionLabel(action.key),
            }));
            await this.load();
        });
        await this.load();
    }

    public ngOnDestroy() {
        if (this.langSub) this.langSub.unsubscribe();
    }

    private callApi(name: string, payload: any = {}) {
        return wiz.call(name, {
            ...payload,
            lang: this.translate.currentLang || this.translate.getDefaultLang() || 'ko',
        });
    }

    public async load() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        const { code, data } = await this.callApi("list", this.search);
        if (code === 200) {
            this.members = data?.members || [];
            this.organizations = data?.organizations || [];
            this.roles = data?.roles || [];
            this.currentRole = data?.current_role || 'viewer';
            this.canManageMembers = !!data?.can_manage;
            this.logPolicy = { user_activity: data?.log_policy?.user_activity !== false };
            this.canViewUserLogs = this.currentRole === 'superadmin' && this.logPolicy.user_activity !== false;
            if (!this.canViewUserLogs && this.activeTab === 'user_logs') this.activeTab = 'members';
            this.assignableRoles = data?.assignable_roles || [];
            this.logUsers = data?.log_users || [];
            this.activityEventTypes = (data?.activity_event_types || []).map((item: any) => ({
                ...item,
                label: this.localizedEventTypeLabel(item?.key, item?.label),
            }));
            this.sidebarPolicy = this.clonePolicy(data?.sidebar_policy?.roles || {});
            this.sidebarPolicyRoles = data?.sidebar_policy_roles || ['admin', 'operator', 'viewer'];
            this.permissionActions = (data?.sidebar_policy_actions || this.permissionActions).map((action: any) => {
                const key = typeof action === 'string' ? action : action?.key;
                return {
                    key,
                    label: this.permissionLabel(key),
                };
            });
            this.sidebarPolicySections = this.buildPolicySections(data?.sidebar_policy?.catalog || []);
            this.policyDirty = false;
            if (!this.sidebarPolicyRoles.includes(this.selectedPolicyRole)) {
                this.selectedPolicyRole = this.sidebarPolicyRoles[0] || 'admin';
            }
            if (!this.assignableRoles.includes(this.inviteData.role)) {
                this.inviteData.role = this.assignableRoles[0] || 'viewer';
            }
            if (this.logFilters.user_id && !this.logUsers.some((item: any) => item.id === this.logFilters.user_id)) {
                this.logFilters.user_id = '';
            }
        } else {
            this.members = [];
            this.organizations = [];
            this.roles = [];
            this.assignableRoles = [];
            this.canManageMembers = false;
            this.canViewUserLogs = false;
            this.logUsers = [];
            this.activityEventTypes = [];
            this.sidebarPolicy = {};
            this.sidebarPolicySections = [];
            this.error = data || this.translate.instant('page.members.error_access');
        }

        this.loading = false;
        await this.service.render();
    }

    public buildPolicySections(catalog: any[]) {
        const sections: any = {};
        for (const item of catalog || []) {
            if (!item?.key || item?.min_role === 'superadmin') continue;
            const group = this.localizedPolicyGroup(item?.group || this.translate.instant('page.members.etc_group'));
            if (!sections[group]) sections[group] = [];
            sections[group].push({
                ...item,
                label: this.localizedPolicyLabel(item?.key, item?.label),
                group,
            });
        }
        return Object.keys(sections).map((group) => ({
            title: group,
            items: sections[group]
        }));
    }

    public async switchTab(tab: string) {
        if (tab === 'user_logs' && !this.canViewUserLogs) return;
        this.activeTab = tab;
        await this.service.render();
        if (tab === 'user_logs' && this.userLogs.length === 0) {
            await this.loadUserLogs(1);
        }
    }

    public clonePolicy(source: any) {
        return JSON.parse(JSON.stringify(source || {}));
    }

    public permissionLabel(action: string) {
        switch (action) {
            case 'read': return this.translate.instant('page.members.permission.read');
            case 'create': return this.translate.instant('page.members.permission.create');
            case 'update': return this.translate.instant('page.members.permission.update');
            case 'remove': return this.translate.instant('page.members.permission.remove');
            case 'execute': return this.translate.instant('page.members.permission.execute');
            default: return action || '';
        }
    }

    private isEnglishLanguage() {
        return String(this.translate.currentLang || this.translate.getDefaultLang() || 'ko').toLowerCase().startsWith('en');
    }

    private localizedPolicyGroup(group: string) {
        if (!this.isEnglishLanguage()) return group || '';

        const normalized = String(group || '').trim();
        switch (normalized) {
            case '기본': return this.POLICY_GROUP_LABELS.basic;
            case '이미지': return this.POLICY_GROUP_LABELS.image;
            case '설정': return this.POLICY_GROUP_LABELS.settings;
            case '도구': return this.POLICY_GROUP_LABELS.tools;
            case '로그': return this.POLICY_GROUP_LABELS.logs;
            case '기타': return this.POLICY_GROUP_LABELS.misc;
            default: return normalized;
        }
    }

    private localizedPolicyLabel(key: string, fallback: string) {
        if (!this.isEnglishLanguage()) return fallback || key || '';
        return this.POLICY_MENU_LABELS[String(key || '').trim()] || fallback || key || '';
    }

    private localizedEventTypeLabel(key: string, fallback: string) {
        if (!this.isEnglishLanguage()) return fallback || key || '';
        return this.ACTIVITY_EVENT_LABELS[String(key || '').trim()] || fallback || key || '';
    }

    public permissionState(role: string, key: string) {
        const rolePolicy = this.sidebarPolicy?.[role] || {};
        const stored = rolePolicy?.[key] || {};
        return {
            read: !!stored.read,
            create: !!stored.create,
            update: !!stored.update,
            remove: !!stored.remove,
            execute: !!stored.execute,
        };
    }

    public isPermissionEnabled(role: string, key: string, action: string) {
        return !!this.permissionState(role, key)?.[action as keyof object];
    }

    public async togglePermission(role: string, key: string, action: string, checked: boolean) {
        const rolePolicy = {
            ...(this.sidebarPolicy?.[role] || {}),
        };
        const next = this.permissionState(role, key);
        next[action as keyof typeof next] = checked;

        if (action === 'read' && !checked) {
            next.create = false;
            next.update = false;
            next.remove = false;
            next.execute = false;
        }
        if (action !== 'read' && checked) {
            next.read = true;
        }

        rolePolicy[key] = next;
        this.sidebarPolicy = {
            ...this.sidebarPolicy,
            [role]: rolePolicy,
        };
        this.policyDirty = true;
        await this.service.render();
    }

    public async saveSidebarPolicy() {
        this.savingPolicy = true;
        await this.service.render();

        const { code, data } = await this.callApi('save_sidebar_policy', {
            policy: JSON.stringify(this.sidebarPolicy || {}),
        });

        this.savingPolicy = false;
        if (code === 200) {
            this.sidebarPolicy = this.clonePolicy(data?.roles || this.sidebarPolicy);
            this.policyDirty = false;
            await this.service.auth.loadPermissions(true);
            window.dispatchEvent(new CustomEvent('sidebar-policy-updated'));
            await this.service.modal.success(this.translate.instant('page.members.policy_saved'));
            await this.service.render();
            return;
        }

        await this.service.modal.error(data || this.translate.instant('page.members.policy_save_failed'));
        await this.service.render();
    }

    public organizationPathLabel(id: string) {
        const normalizedId = String(id || '').trim();
        if (!normalizedId) return '';

        const byId: any = {};
        for (const item of this.organizations || []) {
            byId[item.id] = item;
        }

        const names: string[] = [];
        const visited: any = {};
        let currentId = normalizedId;
        while (currentId && byId[currentId] && !visited[currentId]) {
            visited[currentId] = true;
            const current = byId[currentId];
            names.unshift(current.name || current.id || '');
            currentId = String(current.parent_id || '').trim();
        }

        return names.filter(Boolean).join(' / ');
    }

    public async loadUserLogs(page: number = 1) {
        this.logsLoading = true;
        this.logPagination.page = page;
        await this.service.render();

        const { code, data } = await this.callApi('user_logs', {
            user_id: this.logFilters.user_id || '',
            event_type: this.logFilters.event_type || '',
            start_date: this.logFilters.start_date || '',
            end_date: this.logFilters.end_date || '',
            page,
            dump: this.logPagination.dump,
        });

        if (code === 200) {
            this.userLogs = data?.rows || [];
            this.logPagination = {
                page: data?.page || page,
                dump: data?.dump || this.logPagination.dump,
                total: data?.total || 0,
            };
        } else {
            this.userLogs = [];
            this.logPagination = { ...this.logPagination, total: 0 };
            await this.service.modal.error(data || this.translate.instant('page.members.user_logs_load_failed'));
        }

        this.logsLoading = false;
        await this.service.render();
    }

    public async applyLogFilters() {
        await this.loadUserLogs(1);
    }

    public async moveLogPage(direction: number) {
        const nextPage = this.logPagination.page + direction;
        const totalPages = this.totalLogPages();
        if (nextPage < 1 || nextPage > totalPages) return;
        await this.loadUserLogs(nextPage);
    }

    public totalLogPages() {
        return Math.max(1, Math.ceil((this.logPagination.total || 0) / (this.logPagination.dump || 1)));
    }

    public totalLogsText() {
        return this.translate.instant('page.members.total_logs', {
            count: Number(this.logPagination?.total || 0),
        });
    }

    public pageCounterText() {
        return this.translate.instant('page.members.page_counter', {
            page: Number(this.logPagination?.page || 1),
            total: this.totalLogPages(),
        });
    }

    public editUserDescText() {
        return this.translate.instant('page.members.edit_user_desc', {
            name: this.memberEditData?.name || '',
        });
    }

    public eventTypeLabel(eventType: string) {
        const item = (this.activityEventTypes || []).find((entry: any) => entry.key === eventType);
        return this.localizedEventTypeLabel(eventType, item?.label || eventType || '-');
    }

    public logUserLabel(row: any) {
        return row?.actor_name || row?.actor_email || row?.actor_id || '-';
    }

    public logStatusClass(status: string) {
        return status === 'success'
            ? 'bg-emerald-100 text-emerald-700'
            : 'bg-rose-100 text-rose-700';
    }

    public logTargetLabel(row: any) {
        if (!row?.target_type && !row?.target_id) return '-';
        if (!row?.target_id) return row?.target_type || '-';
        return `${row?.target_type || 'target'}:${row?.target_id}`;
    }

    public logSummary(row: any) {
        const items = [
            this.eventTypeLabel(row?.event_type),
            this.previewText(row?.action, ''),
            this.logTargetLabel(row),
            this.logDetailSummary(row),
        ].filter((item: string) => {
            const text = String(item || '').trim();
            return text && text !== '-';
        });
        return items.join(' · ') || '-';
    }

    public logDetailSummary(row: any) {
        const raw = row?.detail;
        if (raw === undefined || raw === null || raw === '') return '';

        let detail: any = raw;
        if (typeof raw === 'string') {
            const text = raw.trim();
            if (!text) return '';
            if (text.startsWith('{') || text.startsWith('[')) {
                try {
                    detail = JSON.parse(text);
                } catch (e) {
                    return this.truncateText(text.replace(/\s+/g, ' '), 120, '');
                }
            } else {
                return this.truncateText(text.replace(/\s+/g, ' '), 120, '');
            }
        }

        if (Array.isArray(detail)) {
            return this.truncateText(detail.map((item: any) => this.previewText(item, '')).filter(Boolean).join(', '), 120, '');
        }
        if (typeof detail !== 'object') return this.truncateText(detail, 120, '');

        if (detail.summary) return this.truncateText(detail.summary, 120, '');
        if (detail.error) return this.truncateText(detail.error, 120, '');

        const parts: string[] = [];
        if (detail.cluster_name) parts.push(`cluster=${detail.cluster_name}`);
        if (detail.group_name) parts.push(`group=${detail.group_name}`);
        if (detail.name) parts.push(`name=${detail.name}`);
        if (detail.image_name) parts.push(`image=${detail.image_name}`);
        if (detail.image_id) parts.push(`image_id=${detail.image_id}`);
        if (detail.execution_mode) parts.push(`mode=${detail.execution_mode}`);

        const targetCount = Number(detail.target_count ?? detail.node_count ?? 0);
        if (targetCount > 0) {
            parts.push(`targets=${targetCount}`);
        } else if (Array.isArray(detail.node_ids)) {
            parts.push(`targets=${detail.node_ids.length}`);
        }

        const operationCount = Number(detail.operation_count ?? 0);
        if (operationCount > 0) parts.push(`operations=${operationCount}`);

        if (parts.length === 0) {
            try {
                return this.truncateText(JSON.stringify(detail), 120, '');
            } catch (e) {
                return '';
            }
        }

        return this.truncateText(parts.join(', '), 120, '');
    }

    public previewText(value: any, fallback: string = '-') {
        const text = String(value ?? '').trim();
        return text || fallback;
    }

    public truncateText(value: any, limit: number = 25, fallback: string = '-') {
        const text = this.previewText(value, fallback);
        if (text === fallback) return text;

        const maxLength = Math.max(1, Number(limit || 0));
        if (text.length <= maxLength) {
            return text;
        }

        if (maxLength <= 3) {
            return '.'.repeat(maxLength);
        }

        return `${text.slice(0, maxLength - 3)}...`;
    }

    public async filterByRole(role: string) {
        this.search.role = this.search.role === role ? "" : role;
        await this.load();
    }

    public async openInvite() {
        if (!this.canManageMembers) {
            await this.service.modal.error(this.translate.instant('page.members.error_cannot_create_user'));
            return;
        }

        this.inviteData = {
            email: '',
            role: this.assignableRoles[0] || 'viewer',
            password: ''
        };
        this.showInviteModal = true;
        await this.service.render();
    }

    public async invite() {
        if (!this.canManageMembers) {
            await this.service.modal.error(this.translate.instant('page.members.error_cannot_create_user'));
            return;
        }
        if (!this.inviteData.email) {
            await this.service.modal.error(this.translate.instant('page.members.email_required'));
            return;
        }
        if (!this.passwordPolicyValid(this.inviteData.password)) {
            await this.service.modal.error(this.translate.instant('page.members.initial_password_min'));
            return;
        }

        const { code, data } = await this.callApi("invite", this.inviteData);
        if (code === 200) {
            await this.service.modal.success(this.translate.instant('page.members.user_created'));
            this.showInviteModal = false;
            await this.load();
        } else {
            await this.service.modal.error(data || this.translate.instant('page.members.user_create_failed'));
        }
    }

    public async applyFilters() {
        await this.load();
    }

    public async removeMember(member: any) {
        if (!member?.canRemove) {
            await this.service.modal.error(this.translate.instant('page.members.member_cannot_remove'));
            return;
        }

        let res = await this.service.modal.show({
            title: this.translate.instant('page.members.member_remove_title'),
            message: this.translate.instant('page.members.member_remove_message', { name: member.name }),
            action: this.translate.instant('page.members.member_remove_action'),
            actionBtn: "error",
            status: "error"
        });
        if (!res) return;

        const { code } = await this.callApi("remove", { id: member.id });
        if (code === 200) {
            await this.load();
        }
    }

    public async updateMemberRole(member: any, role: string) {
        if (!member?.canEditRole) {
            await this.service.modal.error(this.translate.instant('page.members.role_cannot_change'));
            return;
        }

        const previousRole = member.role;
        member.role = role;
        await this.service.render();

        const { code, data } = await this.callApi("update_role", { id: member.id, role: role });
        if (code === 200) {
            await this.service.modal.success(this.translate.instant('page.members.role_updated'));
            await this.load();
            return;
        }

        member.role = previousRole;
        await this.service.modal.error(data || this.translate.instant('page.members.role_update_failed'));
        await this.service.render();
    }

    public async openMemberEditModal(member: any) {
        if (!this.canManageMembers) {
            await this.service.modal.error(this.translate.instant('page.members.member_edit_forbidden'));
            return;
        }
        this.memberEditData = {
            id: member.id,
            name: member.name || member.email || member.id,
            email: member.email || '',
            password: '',
            confirm_password: '',
        };
        this.showMemberEditModal = true;
        await this.service.render();
    }

    public async saveMemberEdit() {
        if (!String(this.memberEditData.email || '').trim()) {
            await this.service.modal.error(this.translate.instant('page.members.email_required'));
            return;
        }
        if (this.memberEditData.password && !this.passwordPolicyValid(this.memberEditData.password)) {
            await this.service.modal.error(this.translate.instant('page.members.password_min'));
            return;
        }

        if (this.memberEditData.password !== this.memberEditData.confirm_password) {
            await this.service.modal.error(this.translate.instant('page.members.password_mismatch'));
            return;
        }

        const payload = {
            email: String(this.memberEditData.email || '').trim(),
            password: String(this.memberEditData.password || ''),
        };

        const { code, data } = await this.callApi("update_member", {
            id: this.memberEditData.id,
            data: JSON.stringify(payload),
        });
        if (code === 200) {
            await this.service.modal.success(this.translate.instant('page.members.member_updated'));
            this.showMemberEditModal = false;
            this.memberEditData = { id: '', name: '', email: '', password: '', confirm_password: '' };
            await this.load();
            return;
        }
        await this.service.modal.error(data || this.translate.instant('page.members.member_update_failed'));
    }

    private passwordPolicyValid(password: string): boolean {
        const value = String(password || '');
        if (value.length < 10) return false;
        const classes = [
            /[a-z]/.test(value),
            /[A-Z]/.test(value),
            /[0-9]/.test(value),
            /[^A-Za-z0-9]/.test(value),
        ];
        return classes.filter(Boolean).length >= 2;
    }

    public organizationDisplayName(member: any) {
        const organizationId = String(member?.organization_id || '').trim();
        if (!organizationId) return '-';
        return this.organizationPathLabel(organizationId) || member?.organization_name || '-';
    }

    public roleClass(role: string) {
        switch (role) {
            case 'superadmin': return 'bg-rose-100 text-rose-700';
            case 'admin': return 'bg-purple-100 text-purple-700';
            case 'operator': return 'bg-blue-100 text-blue-700';
            case 'viewer': return 'bg-gray-100 text-gray-600';
            default: return 'bg-gray-100 text-gray-600';
        }
    }

    public roleLabel(role: string) {
        switch (role) {
            case 'superadmin': return 'SuperAdmin';
            case 'admin': return 'Admin';
            case 'operator': return 'Operator';
            case 'viewer': return 'Viewer';
            default: return role || 'Viewer';
        }
    }
}

export default PageMembersComponent;
